import { render, staticRenderFns } from "./ApplicantRoles.vue?vue&type=template&id=c79e7f5c"
import script from "./ApplicantRoles.vue?vue&type=script&lang=js"
export * from "./ApplicantRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports